export type VenueBackstageAction =
  | {
      kind: 'claim';
      buttonLabel: 'Claim in Backstage';
      helperText: 'Own or run this venue? Claim it and manage events, deals, and your team.';
      url: string;
    }
  | {
      kind: 'open';
      buttonLabel: 'Open in Backstage';
      helperText: 'Manage events, deals, team access, and analytics.';
      url: string;
    };

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '');
}

export function buildBackstageURL(
  baseURL: string,
  kind: VenueBackstageAction['kind'],
  venueID?: string | null
) {
  const normalized = trimTrailingSlash(baseURL);
  if (kind === 'claim') {
    if (venueID) {
      return `${normalized}/claim?venue_id=${encodeURIComponent(venueID)}`;
    }
    return `${normalized}/claim`;
  }
  return normalized;
}

export function getVenueBackstageAction({
  backstageBaseURL,
  venueID,
  claimed,
  managedByViewer,
}: {
  backstageBaseURL: string;
  venueID?: string | null;
  claimed: boolean;
  managedByViewer: boolean;
}): VenueBackstageAction | null {
  if (!claimed) {
    return {
      kind: 'claim',
      buttonLabel: 'Claim in Backstage',
      helperText: 'Own or run this venue? Claim it and manage events, deals, and your team.',
      url: buildBackstageURL(backstageBaseURL, 'claim', venueID),
    };
  }

  if (managedByViewer) {
    return {
      kind: 'open',
      buttonLabel: 'Open in Backstage',
      helperText: 'Manage events, deals, team access, and analytics.',
      url: buildBackstageURL(backstageBaseURL, 'open', venueID),
    };
  }

  return null;
}
